<template>
  <v-card height="auto">
    <vue-card-title
      title="View CRM User Details"
      subtitle="Here you can see the CRM user details."
      :icon="$getIcon('mdiEyeOutline')"
      closable
      dark
      @close="$emit('close')"
    ></vue-card-title>
    <v-card-text class="py-4 scrollbar-md">
      <div v-if="actionData.id">
        <v-row>
          <v-col v-for="(item, index) in details" :key="index" md="4" cols="12">
            <v-row no-gutters>
              <v-col cols="12">
                <v-icon v-text="$getIcon('mdiInformationOutline')"></v-icon>
                {{ item.name }}
              </v-col>
              <v-col cols="12" class="pl-7 black--text">
                <div v-if="item.name === 'Profile Picture'">
                  <v-img
                    :src="item.value"
                    style="height: 80px; width: 80px; border:2px solid #efefef;"
                  >
                  </v-img>
                </div>
                <div v-else>{{ item.value || "N/A" }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <vue-no-data v-else></vue-no-data>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters>
        <v-col class="text-right">
          <v-btn text @click="$emit('close')" class="text-capitalize">
            Cancel
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    actionData: {
      type: [Object, Array],
      required: true
    }
  },
  data() {
    return {
      details: [
        {
          name: "Name",
          value: this.fullName(this.actionData)
        },
        {
          name: "Organzation Name",
          value:
            this.actionData.organization && this.actionData.organization.name
        },
        {
          name: "Gender",
          value: this.actionData.gender
        },
        {
          name: "Email",
          value: this.actionData.email
        },
        {
          name: "Profile Picture",
          value: this.actionData.picture
        }
      ]
    };
  },
  methods: {
    fullName(item) {
      return item.given_name
        ? `${item.given_name} ${item.middle_name} ${item.family_name}`
        : "N/A";
    }
  }
};
</script>
